import { GetMenuLink } from '@/components/tables/PolicyTransactionTable/GetMenuLink';
import { Box, useTheme } from '@mui/material';
import React from 'react';

const DataGridDealActions = ({ row }) => {
	const theme = useTheme();
	return (
		<Box
			className='actions-cell'
			sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				width: '100%',
				backgroundColor: theme.palette.background.paper,
			}}
		>
			<GetMenuLink
				deal={row}
				slotProps={{
					button: {
						size: 'small',
					},
				}}
			/>
		</Box>
	);
};
DataGridDealActions.displayName = 'DataGridDealActions';
export default DataGridDealActions;
